import React, { useEffect, useState } from "react";
import {
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Input,
  Button,
} from "@chakra-ui/react";
import { ChevronDownIcon } from "@chakra-ui/icons";
import Fuse from "fuse.js";

type IProps = {
  options: { id: number; label: string }[];
  placeHolder?: string;
  selectedOption: string;
  onChange: (selectedOption: string) => void;
};

const DropdownWithSearch = ({
  options,
  onChange,
  placeHolder,
  selectedOption: sOption,
}: IProps) => {
  const [search, setSearch] = useState("");
  const [filteredOptions, setFilteredOptions] = useState(options);
  const [selectedOption, setSelectedOption] = useState<string | null>(null);
  const fuse = new Fuse(options, { keys: ["label"], threshold: 0.3 });

  useEffect(() => {
    if (sOption) {
      setSelectedOption(sOption);
    }
  }, [sOption]);

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    const query = e.target.value;
    setSearch(query);
    setFilteredOptions(
      query ? fuse.search(query).map((result) => result.item) : options
    );
  };

  const handleSelect = (option: string) => {
    setSelectedOption(option);
    if (onChange) {
      onChange(option);
    }
  };

  return (
    <Menu matchWidth>
      <MenuButton
        as={Button}
        variant="outline"
        width="full"
        rightIcon={<ChevronDownIcon />}
      >
        {selectedOption || (placeHolder ?? "Select an option")}
      </MenuButton>
      <MenuList minW="100%" width="full" bg={"background"}>
        <Input
          placeholder="Search..."
          value={search}
          onChange={handleSearch}
          mb={2}
          px={2}
        />
        {filteredOptions.length > 0 ? (
          filteredOptions.map((option) => (
            <MenuItem
              key={option.id}
              _hover={{ bg: "neutral.700" }}
              bg={"background"}
              onClick={() => handleSelect(option.label)} // Set selected option
            >
              {option.label}
            </MenuItem>
          ))
        ) : (
          <MenuItem disabled>No results found</MenuItem>
        )}
      </MenuList>
    </Menu>
  );
};

export default DropdownWithSearch;
